/* eslint-disable react-hooks/rules-of-hooks */
import {range} from "lodash";
import {useTranslation} from "ni18n";
import React from "react";

import {useV5ImgSrc} from "../../../useV5ImgSrc";
import styles from "./Partners.module.scss";

const heights = [15, 58, 37, 60, 60];

const Partners = () => {
  const i18n = useTranslation();
  return (
    <div className={styles.wrap} id="partners">
      <div className={styles.inner}>
        <h5 className={styles.head}>{i18n.t("These Partners are COVID Ready")}</h5>
        <div className={styles.partners}>
          {range(5).map((l, i) => (
            <img
              key={i}
              src={useV5ImgSrc(`/covidReady3/partners${i}`)}
              alt={`partner${i}`}
              height={heights[i]}
            />
          ))}
        </div>

        <h4 className={styles.copy}>
          <span className="cIcon-quote" />
          {i18n.t(
            "We were impressed with Carbon Health’s sharp focus on COVID-19 and data, and have partnered with them to provide tools to keep our employees safe as we build back to a better future.",
          )}
        </h4>

        <div className={styles.who}>
          <div className={styles.who1}>{i18n.t("Sholeh Esmaili-Montoya")}</div>
          <div className={styles.who2}>{i18n.t("Vice President of People & Places")}</div>
          <div className={styles.who2}>{i18n.t("Bolt Threads")}</div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Partners);
